import { render, staticRenderFns } from "./HandoverTemplateCreation.vue?vue&type=template&id=09c8d2d3&scoped=true"
import script from "./HandoverTemplateCreation.vue?vue&type=script&lang=ts"
export * from "./HandoverTemplateCreation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c8d2d3",
  null
  
)

export default component.exports